module.exports = __webpack_public_path__ + "static/media/UPV_Logo.2228d9b4.png";